import React from "react";
import { cn } from "../lib/utils";

type PolymorphicRef<T extends React.ElementType> =
    React.ComponentPropsWithRef<T>["ref"];

type TypographyTags = "p" | "h1" | "h2" | "h3" | "h4" | "span";

type TypographyProps<T extends TypographyTags = "p"> =
    React.ComponentPropsWithoutRef<T> & {
        tag?: T;
        className?: string;
    };

const VARIANT_STYLES: Record<TypographyTags, string> = {
    h1: "uppercase font-bold text-[40px] md:text-[80px]",
    h2: "uppercase font-bold text-[20px] md:text-[26px]",
    h3: "uppercase font-semibold text-[16px] md:text-[18px]",
    h4: "uppercase font-normal text-[14px] md:text-[16px]",
    p: "font-medium text-[14px] md:text-[16px]",
    span: "font-normal text-[10px]",
};

const Typography = React.forwardRef(
    <T extends TypographyTags = "p">(
        { tag, className, children, ...props }: TypographyProps<T>,
        ref: PolymorphicRef<T>
    ) => {
        const Component = (tag ?? "p") as React.ElementType;

        return (
            <Component
                ref={ref}
                className={cn('font-manrope !leading-none tracking-[0]', VARIANT_STYLES[tag ?? "p"], className)}
                
                {...props}
            >
                {children}
            </Component>
        );
    }
);

Typography.displayName = "Typography";

export default Typography;
